import styles from './FeaturesGroups.module.css';

export default function FeaturesGroups() {
  return (
    <div className={styles.container}>
      <div className={styles.overlay} />
      <div className={styles.content}>
        <h1 className={styles.title}>Groups: Organize Your Contacts Like Never Before</h1>

        <div className={styles.introSection}>
          <p className={styles.subtitle}>
            Transform how you manage your relationships with powerful group organization features
            that adapt to your life and work.
          </p>
        </div>

        <div className={styles.featuresContainer}>
          <div className={styles.feature}>
            <h2>Smart Group Creation</h2>
            <p>
              Create unlimited custom groups to organize your contacts exactly how you think about
              them. From family and friends to business networks and hobby communities.
            </p>
          </div>

          <div className={styles.feature}>
            <h2>Multi-Group Membership</h2>
            <p>
              Contacts can belong to multiple groups simultaneously. Your college friend who's now a
              business partner can be in both "Friends" and "Business Contacts" groups.
            </p>
          </div>

          {/*<div className={styles.feature}>
            <h2>Nested Group Hierarchies</h2>
            <p>Create sub-groups within groups for detailed organization. Have "Family" with sub-groups like "Immediate Family," "Extended Family," and "In-Laws."</p>
          </div>*/}

          <div className={styles.feature}>
            <h2>Dynamic Group Filtering</h2>
            <p>
              Instantly filter your entire contact database by one or multiple groups to find
              exactly who you're looking for in seconds.
            </p>
          </div>

          <div className={styles.feature}>
            <h2>Group-Based Actions</h2>
            <p>
              Perform bulk actions on entire groups - send group emails, export group contacts, or
              update group information all at once.
            </p>
          </div>

          <div className={styles.feature}>
            <h2>Visual Group Management</h2>
            <p>
              Color-code your groups and see at a glance which groups each contact belongs to with
              intuitive visual indicators.
            </p>
          </div>
        </div>

        <div className={styles.useCasesSection}>
          <h2>Real-World Use Cases</h2>
          <div className={styles.useCasesGrid}>
            <div className={styles.useCase}>
              <h3>Personal Life</h3>
              <ul>
                <li>
                  <strong>Family Gatherings:</strong> Quickly find all family members for holiday
                  invitations
                </li>
                <li>
                  <strong>Friend Circles:</strong> Organize by how you know them - college, work,
                  neighborhood
                </li>
                <li>
                  <strong>Special Events:</strong> Create temporary groups for weddings, parties, or
                  reunions
                </li>
                <li>
                  <strong>Emergency Contacts:</strong> Keep important contacts easily accessible
                </li>
              </ul>
            </div>

            <div className={styles.useCase}>
              <h3>Professional Networks</h3>
              <ul>
                <li>
                  <strong>Industry Contacts:</strong> Group by profession, company, or industry
                  sector
                </li>
                <li>
                  <strong>Project Teams:</strong> Organize contacts by current and past projects
                </li>
                <li>
                  <strong>Networking Events:</strong> Track where you met professional contacts
                </li>
                <li>
                  <strong>Vendors & Suppliers:</strong> Keep business relationships organized
                </li>
              </ul>
            </div>

            <div className={styles.useCase}>
              <h3>Community & Hobbies</h3>
              <ul>
                <li>
                  <strong>Sports Teams:</strong> Track teammates, coaches, and league contacts
                </li>
                <li>
                  <strong>Volunteer Organizations:</strong> Organize fellow volunteers and
                  coordinators
                </li>
                <li>
                  <strong>Hobby Groups:</strong> Photography clubs, book clubs, gaming groups
                </li>
                <li>
                  <strong>Neighborhood:</strong> Neighbors, local services, community leaders
                </li>
              </ul>
            </div>

            <div className={styles.useCase}>
              <h3>Special Situations</h3>
              <ul>
                <li>
                  <strong>Medical Network:</strong> Doctors, specialists, insurance contacts
                </li>
                <li>
                  <strong>Children's Activities:</strong> Other parents, coaches, teachers
                </li>
                <li>
                  <strong>Travel Contacts:</strong> Local contacts in different cities or countries
                </li>
                <li>
                  <strong>Service Providers:</strong> Contractors, repair services, maintenance
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className={styles.benefitsSection}>
          <h2>Key Benefits</h2>
          <div className={styles.benefitsGrid}>
            <div className={styles.benefit}>
              <h3>🎯 Precision Targeting</h3>
              <p>
                Find exactly the right people for any situation without scrolling through hundreds
                of contacts.
              </p>
            </div>

            <div className={styles.benefit}>
              <h3>⚡ Lightning Fast</h3>
              <p>
                Group filtering happens instantly, making contact management effortless even with
                thousands of contacts.
              </p>
            </div>

            <div className={styles.benefit}>
              <h3>🧠 Mental Mapping</h3>
              <p>
                Organize contacts the way your brain naturally thinks about relationships and
                contexts.
              </p>
            </div>

            <div className={styles.benefit}>
              <h3>📊 Better Insights</h3>
              <p>
                Understand your network better by seeing how your relationships are distributed
                across different areas of life.
              </p>
            </div>

            <div className={styles.benefit}>
              <h3>🔄 Flexible Evolution</h3>
              <p>
                Groups can change as your life changes - easily reorganize as relationships and
                priorities shift.
              </p>
            </div>

            <div className={styles.benefit}>
              <h3>💼 Professional Edge</h3>
              <p>
                Maintain your professional network more effectively with organized, accessible
                contact groups.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.ctaSection}>
          <h2>Ready to Transform Your Contact Management?</h2>
          <p>
            Experience the power of intelligent group organization and take control of your
            relationships like never before.
          </p>
          <div className={styles.ctaButtons}>
            <a href="/download" className={styles.primaryButton}>
              Download Now
            </a>
            <a href="/features" className={styles.secondaryButton}>
              View All Features
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
